import styled from '@emotion/styled';
import { colors } from '@naf-simba/theme';

const StyledButton = styled.button`
  /* reset style */
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  touch-action: manipulation;
  appearance: none !important;

  /* style */
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    color: ${colors.secondary[500]};
  }
`;

export default { StyledButton };
